import { createSlice } from "@reduxjs/toolkit";

export const fullWithdrawalTimeSlice = createSlice({
  name: "fullWithdrawalTime",
  initialState: {
    timeCount: 0,
  },
  reducers: {
    addTime: (state, action) => {
      state.timeCount += action.payload;
    },
    resetTime: (state) => {
      state.timeCount = 0;
    },
  },
});

export const { addTime, resetTime } = fullWithdrawalTimeSlice.actions;

export default fullWithdrawalTimeSlice.reducer;
